import React from 'react';
import Hint, { HintText } from '@components/basics/hint';
import Grid from '@components/basics/grid';
import { Translate } from 'react-localize-redux';
import Flex from '@components/layout/flex';
import CatalogRelease from '@common/types/catalog/catalog-release';

interface OwnershipLockHintProps {
  activeRelease?: CatalogRelease;
  reassignSplitError: boolean;
  giveawayError: boolean;
}

export const OwnershipLockHint: React.FC<OwnershipLockHintProps> = ({
  reassignSplitError,
  giveawayError,
}) => {
  return reassignSplitError ? (
    <Hint
      error={reassignSplitError}
      noBorderTop
      noTitle
      align="left"
      customContent={
        <Flex justifyContent="space-between" alignItems="center" gap={20}>
          <Grid>
            <HintText>
              <Translate id="OWNERSHIP.HINT.ERROR.SPLITS.TEXT" />
            </HintText>
          </Grid>
        </Flex>
      }
    ></Hint>
  ) : giveawayError ? (
    <Hint
      error={reassignSplitError}
      noBorderTop
      noTitle
      align="left"
      customContent={
        <Flex justifyContent="space-between" alignItems="center" gap={20}>
          <Grid>
            <HintText>
              <Translate id="OWNERSHIP.HINT.GIVEAWAY_ERROR" />
            </HintText>
          </Grid>
        </Flex>
      }
    ></Hint>
  ) : null;
};
